import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const VariantSelector: StyleRule = ({ theme }) => ({
    borderTop: `2px solid ${theme.siteVariables.colors.grey[125]}`,
    maxWidth: pxToRem(896),

    [`&:empty`]: {
        display: 'none',
    },
});
